import React, { useState } from 'react';
import styled from 'styled-components';

import Layout from './components/Layout';
import SearchDrugs from './components/SearchDrugs';
import NavBarContainer from '../../../containers/common/NavBarContainer';


const MenuContainer = styled.div`
    max-width: 1400px;
    margin: auto;
`;

const ManageDrugsContainer = () => {
    const [totalRXCUI, setTotalRXCUI] = useState(0);
    return (
        <>
            <MenuContainer className="grid-row">
                <NavBarContainer navBarClass="manage-drugs-top-nav grid-col-12" />
            </MenuContainer>
            <Layout totalRXCUI={totalRXCUI}>
                <SearchDrugs setTotalRXCUI={setTotalRXCUI} />
            </Layout>
        </>
    );
};

export default ManageDrugsContainer;